import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";
import arrowright from "../../assets/arrowright.svg";
import Edit from "../../assets/Edit.svg";
import deleteicon from "../../assets/Order/Delete.svg";

const HampersTable = ({ additionalData, pagination, showDrawer, onRowClick ,DeleteProductTax ,handleEditClick ,canEdit}) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )


  const openOrderList = (id) => {
    // console.log("CREDIT CUS TOME id", id);

    // navigate(`/customerCreditOrder?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );


  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);



const columns = useMemo(
  () => [
    {
      Header: (
        <div className="text-start justify-start" title={t("Barcode")}>
          {t("Barcode")}
        </div>
      ),
      width: "20%",
      accessor: "barcode",
      Cell: ({ row }) => (
        <div className="text-start justify-start">
          {row.original.barcode}
        </div>
      ),
    },

    {
      Header: (
        <div className="text-start justify-start">
          {t("English Name")}
        </div>
      ),
      width: "20%",
      accessor: "english_name",
      Cell: ({ row }) => (
        <div className="text-start justify-start">
          {row.original.english_name}
        </div>
      ),
    },

    {
      Header: (
        <div className="text-start justify-start">
          {t("Arabic Name")}
        </div>
      ),
      width: "20%",
      accessor: "arabic_name",
      Cell: ({ row }) => (
        <div className="text-start justify-start">
          {row.original.arabic_name}
        </div>
      ),
    },

    {
      Header: <div className="text-start">{t("Items")}</div>,
      width: "10%",
      accessor: "items",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.items}</div>
      ),
    },

    {
      Header: <div className="text-start">{t("Quantity")}</div>,
      width: "10%",
      accessor: "quantity",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.quantity}</div>
      ),
    },

    {
      Header: <div className="text-start">{t("Sales Value")}</div>,
      width: "15%",
      accessor: "sale_price",
      Cell: ({ row }) => (
        <div className="text-start">
          EGP {row.original.sale_price.toFixed(2)}
        </div>
      ),
    },

    // 👉 Only include this block when canEdit === true
    ...(canEdit
      ? [
          {
            Header: t("Actions"),
            accessor: "actions",
            disableSortBy: true,
            width: "15%",
            Cell: ({ row }) => (
              <div className="flex gap-2 justify-start">
                <img
                  src={Edit}
                  className="cursor-pointer h-4 w-4"
                  alt="Edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditClick(row.original);
                  }}
                />

                <img
                  src={deleteicon}
                  className="cursor-pointer h-4 w-4 mx-2"
                  alt="Delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    DeleteProductTax(row.original);
                  }}
                />
              </div>
            ),
          },
        ]
      : []),

    {
      id: "action",
      Header: "",
      disableSortBy: true,
      width: "10%",
      Cell: ({ row }) => (
        <button className="text-[#1b4497] rounded-lg">
          <img
            src={arrowright}
            alt="arrowright"
            className={`${i18n.language === "en" ? "" : "rotate-180"}`}
            height={3}
            width={20}
          />
        </button>
      ),
    },
  ],
  [t, canEdit, DeleteProductTax, handleEditClick]
);



  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);


  const handlePageSizeChange = (newPageSize) => {
    // Ensure the current page doesn't exceed the total available pages
    const maxPageIndex = Math.ceil(data.length / newPageSize);
    if (pageIndex > maxPageIndex) {
      setpageIndex(maxPageIndex); // Adjust the pageIndex to the last available page
    }

    setPageSize(newPageSize);
  };


  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                             <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                                      {column.render("Header")}
                                                                                                      {column.canSort && (
                                                                                                        <span className="ms-1">
                                                                                                          {column.isSorted ? (
                                                                                                            column.isSortedDesc ? (
                                                                                                              <img
                                                                                                                src={Vectorsorting}
                                                                                                                style={{
                                                                                                                  minHeight: 10,
                                                                                                                  minWidth: 10,
                                                                                                                }}
                                                                                                                alt="vector"
                                                                                                              />
                                                                                                            ) : (
                                                                                                              <img
                                                                                                                className="rotate-180"
                                                                                                                src={Vectorsorting}
                                                                                                                alt="vector"
                                                                                                              />
                                                                                                            )
                                                                                                          ) : (
                                                                                                            // 👇 Show a neutral icon when column is not sorted
                                                                                                            <img
                                                                                                              src={Vectorsorting}
                                                                                                              alt="sortable"
                                                                                                              style={{
                                                                                                                minHeight: 10,
                                                                                                                minWidth: 10,
                                                                                                                opacity: 0.3,
                                                                                                              }}
                                                                                                            />
                                                                                                          )}
                                                                                                        </span>
                                                                                                      )}
                                                                                                    </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                           onClick={() => onRowClick && onRowClick(row.original)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={handlePageSizeChange}

              // setPageSize={(pageSize) => {
              //   setPageSize(pageSize);
              // }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default HampersTable;
